export default "__VITE_ASSET__DvBL0FD$__"